import { currencySymbol } from '../lib/money';

// The agent Cases hub's wording and numbers, in one place.

export const TILE_KEYS = ['attention', 'open', 'matched', 'done'];

// Where each tile and the History circle lead. null = nothing yet: the element is not a link and nothing is invented (LEO-FEEDBACK E39).
export const HUB_TARGETS = { attention: '/cases/attention', open: '/cases/open', matched: '/cases/matched', done: '/cases/done', history: '/cases/history' };

// "$214,380": the company's own currency symbol, whole units, no conversion.
export const moneyText = (amount, currency) => currencySymbol(currency) + Math.round(Number(amount) || 0).toLocaleString('en-GB');

// A tile's count as the server sent it, or null when it did not send one (the page never turns that into a 0).
export const tileCount = (data, key) => {
  const n = data && data.tiles && data.tiles[key] ? data.tiles[key].count : null;
  return typeof n === 'number' && Number.isFinite(n) ? n : null;
};

export const countText = (n) => (n == null ? '' : n.toLocaleString('en-GB'));

export const LABEL_KEY = { attention: 'cases.hub.attention', open: 'cases.hub.open', matched: 'cases.hub.matched', done: 'cases.hub.done' };

// The accent of each tile's number in Leo's board: Needs attention rust, Done green, the others the text colour.
export const NUMBER_COLOR = { attention: 'accent', open: 'text', matched: 'text', done: 'green' };

// Supplier names the way the panel's search compares them: no capitals, no accents.
export const norm = (s) => String(s == null ? '' : s).toLowerCase().normalize('NFD').replace(/\p{M}/gu, '');

// Most companies one selection may hold: the same limit the routes accept (server/agent_cases.js MAX_SUPPLIERS).
export const MAX_COMPANIES = 200;
